// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.scss\"","royalColor":"#276DF1","ripple":"Pulse_ripple__34_SE"};